import styled, { css } from 'styled-components';
import theme from 'src/utils/theme';
import _Text from '../../Text';
import _Title from '../../Title';
import _Topic from '../../Topic';
import _LearnablesLabel from '../LearnablesLabel';
import _MissionCard from './MissionCard';

export const FixFlexBasis = styled.div(
  () => css`
    width: 100%;

    > * {
      flex-basis: unset;
      margin-top: ${theme.sz.s4};
    }
  `,
);

export const LearnablesLabel = styled(_LearnablesLabel)(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s4};
  `,
);

export const MissionCard = styled(_MissionCard)(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s6};
  `,
);

export const Text = styled(_Text).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s6};
    font-size: ${theme.DEPRECATED_ty.medium};
    line-height: ${theme.DEPRECATED_ty.larger};
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s6};
  `,
})(
  ({ theme }) => css`
    > a {
      color: ${theme.co.information80};
    }
  `,
);

export const Title = styled(_Title).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s2};
  `,
})(() => css``);

export const Topic = styled(_Topic).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s2};
  `,
})(() => css``);
